var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listingvatAccountCode" },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      _vm.shouldDisplayPopupEditAccountCode
        ? _c("PopupAccountCodeEdit", {
            ref: "popupAccountCodeEdit",
            attrs: {
              accountsCodes: _vm.accountsCodes,
              tax: _vm.taxToEdit,
              defaultCode: _vm.defaultCode
            },
            on: {
              close: _vm.onClosePopupAccountCodeEdit,
              updateSuccessful: _vm.updateTaxSuccessful
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "typographies-heading-h1" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Codes comptables TVA")))
      ]),
      _vm._v(" "),
      _c("CustomTable", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c(
                  "th",
                  {
                    staticClass:
                      "singleLineHeader listingvatAccountCode__table-label"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-bold" },
                      [_vm._v(_vm._s(_vm.$l10n.__("Label")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "singleLineHeader listingvatAccountCode__table-tva"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-bold" },
                      [_vm._v(_vm._s(_vm.$l10n.__("TVA")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "doubleLineHeader listingvatAccountCode__table-code"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-bold" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__("Codes comptables Vente\n(débits)")
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "doubleLineHeader listingvatAccountCode__table-code"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-bold" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Codes comptables Vente\n(encaissements)"
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "doubleLineHeader listingvatAccountCode__table-code"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-bold" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__("Codes comptables Achats\n(débits)")
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "doubleLineHeader listingvatAccountCode__table-code"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-bold" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Codes comptables Achats\n(encaissements)"
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("th")
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return _vm._l(_vm.vatList, function(tax) {
                return _c("tr", { key: tax.id }, [
                  _c("td", { staticClass: "pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$l10n.__(tax.label)) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$filters.numberFormat(tax.rate)) +
                            " %\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(tax.debit_vat.collected_vat.code) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(tax.collection_vat.collected_vat.code) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(tax.debit_vat.deductible_vat.code) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(tax.collection_vat.deductible_vat.code) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "colActionIcon" },
                    [
                      _c("CompassIconButton", {
                        ref: "editIcon",
                        refInFor: true,
                        attrs: { icon: "edit", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.selectTax(tax)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              })
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }